export const language = {
  requiredInput: "Dit veld is verplicht.",
  invalidEmail: "Email is niet correct",
};

export const placeholders = {
  firstName: "Jan",
  lastName: "Janssens",
  email: "jan.janssens@mail.be",
  contactsubject: "Waarmee kunnen we u helpen?",
  contactmessage: "Stel hier u vraag of opmerking."
}

export const isInDevMode = false;
export const SERVERURL = isInDevMode
  ? "http://localhost:5000"
  : "https://backend.bijnensart.be";

export const GOOGLE_MAPS_API_KEY = "AIzaSyBatGSI57HSdkYt_eW33dL-Y7DmLkRwuwM";
export const GOOGLE_MAP_ID = "8120954a2a3d0c4 ";
